import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  airports: string[];
  banner: string;
  body: string;
  link: string;
  sequence: number | string;
  published: boolean;
}

const fetchSubCategoriesDetails = async (airport: string): Promise<any> => {
  const response = await passengerCMSApi.get(`/api/get-spotlight-section-two`);
  const payload = response.data;

  if (!Array.isArray(payload)) return [];
  const filtered = payload.filter((item: any) => {
    if (!item?.airports) return false;

    const airportList = item.airports.split(",").map((a: string) => a.trim().toLowerCase());

    return airportList.includes(airport.toLowerCase());
  });
  return filtered?.[0];
};

const useSubCategoriesDocumentDetails = (
  airport: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", airport],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails(airport);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails };
